import { IAction } from './types';

export const INITIAL_ACTION: IAction = { type: null, devicesIds: [] };

export default {};
